const maybe = (fn, other) => (value) => {
  if (value === null || value === undefined) return other
  return Object.values(value).every((innerValue) => innerValue === null)
    ? other
    : fn(value)
}

export const SingleLine = maybe(
  (address) =>
    `${address.streetLine}, ${[
      address.locality,
      address.sublocality,
      address.governingDistrict,
      address.postalCode,
    ]
      .filter(Boolean)
      .join(' ')}`,
  '',
)

export const LetterHead = maybe(
  (address) => [
    address.streetLine,
    [
      address.locality,
      address.sublocality,
      address.governingDistrict,
      address.postalCode,
    ]
      .filter(Boolean)
      .join(' '),
  ],
  ['', ''],
)
